document.addEventListener('DOMContentLoaded', (e) => {
    const shopifyCollectionSection = document.querySelector('#shopify-section-more-from-collection');
    const collectionImagesContainer = document.querySelector( '.collection-stacked-images-container' );
    const productInfo = document.querySelector('.Product__InfoWrapper');

    setTimeout( () => {
        const builderAccordion = document.querySelectorAll('.builder-accordion-title');
        if (builderAccordion.length) {
            builderAccordion.forEach( accordion => {
                accordion.addEventListener('click', () => {
                    accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
            })
        }

        if ( shopifyCollectionSection && collectionImagesContainer ) {
            collectionImagesContainer.style.height = (shopifyCollectionSection.offsetHeight + productInfo.offsetHeight ) + 'px';
        }

        const collectionPDPImages = document.querySelector('.collection-stacked-images');
        if (collectionPDPImages) {
            document.addEventListener('scroll', function(e) {
                collectionPDPImages.scrollTop = window.pageYOffset;
            });
        }
    }, 2000)
});
